import { render, staticRenderFns } from "./save-map-tip.vue?vue&type=template&id=496b381e&scoped=true"
import script from "./save-map-tip.vue?vue&type=script&lang=js"
export * from "./save-map-tip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496b381e",
  null
  
)

export default component.exports